const state = {
  confirmAddStatus: {}, // 是否添加投标人
  createCancelStatus: {}, // 是否签到撤销
  haveNoDissentStatus: {}, // 有异议无异议
  startDissentStatus: {}, // 发起异议
};

const actions = {
  async setConfirmAdd({ commit }, obj) {
    commit('CONFORMADD', obj);
  },
  async setCreateCancel({ commit }, obj) {
    commit('CREATECANCEL', obj);
  },
  async setHaveNoDissent({ commit }, obj) {
    commit('HAVENODISSENT', obj);
  },
  async setStartDissent({ commit }, obj) {
    commit('STARTDISSENT', obj);
  },
};

const mutations = {
  ['CONFORMADD'](state, obj) {
    state.confirmAddStatus = obj;
  },
  ['CREATECANCEL'](state, obj) {
    state.createCancelStatus = obj;
  },
  ['HAVENODISSENT'](state, obj) {
    state.haveNoDissentStatus = obj;
  },
  ['STARTDISSENT'](state, obj) {
    state.startDissentStatus = obj;
  },
};

export default {
  state,
  actions,
  mutations,
};
